/**
 * Persist the per-job Ask-lane conversation id across remounts of the
 * Current Ingest pane. Keys are job-scoped; values are conversation UUIDs
 * created with origin `ingest_query`.
 */

const PREFIX = 'axilon.ingestQueryConv.'

/** In-memory set so the Chat tab strip can hide Ask-lane conversations. */
const rememberedIds = new Set<string>()

function storageKey(jobId: string): string {
  return `${PREFIX}${jobId}`
}

function hydrateRemembered(): void {
  if (typeof sessionStorage === 'undefined') return
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i)
    if (!key?.startsWith(PREFIX)) continue
    const id = sessionStorage.getItem(key)
    if (id) rememberedIds.add(id)
  }
}

hydrateRemembered()

export function readIngestQueryConversationId(jobId: string): string | null {
  if (typeof sessionStorage === 'undefined') return null
  const id = sessionStorage.getItem(storageKey(jobId))
  if (id) rememberedIds.add(id)
  return id
}

export function writeIngestQueryConversationId(jobId: string, conversationId: string): void {
  rememberedIds.add(conversationId)
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.setItem(storageKey(jobId), conversationId)
}

export function clearIngestQueryConversationId(jobId: string): void {
  if (typeof sessionStorage === 'undefined') return
  const conversationId = sessionStorage.getItem(storageKey(jobId))
  if (conversationId) rememberedIds.delete(conversationId)
  sessionStorage.removeItem(storageKey(jobId))
}

export function isIngestQueryConversationId(conversationId: string): boolean {
  return rememberedIds.has(conversationId)
}
